export default __webpack_public_path__ + "static/media/wi-cloudy-windy.73f3bd7c.svg";